import Phaser    from 'phaser';
import couvImage from '../../../assets/img/couv.jpg';
import { gameWindowSize, initDelay } from '../../constants/appConstants';

class InitScene extends Phaser.Scene {
    constructor ( config ) {
        super( config );
        Phaser.Scene.call( this, { key: 'InitScene' } );
        this._couvImage = null;
        this.initEvent = null
    }

    init(){
    }

    preload () {
        this.load.image( 'couvImage', couvImage );
    }

    create () {
        this._couvImage = this.add.image( 0, 0, 'couvImage' );
        this._couvImage.setDisplaySize(gameWindowSize.width, gameWindowSize.height);
        this._couvImage.setOrigin( 0, 0 );
        this._couvImage.depth = 200;


        this.initEvent = this.time.addEvent( {
            delay: initDelay,
            callback: () => {
                this.scene.launch('MainScene');
                this.scene.launch('PauseScene');
                this._couvImage.destroy();
            },
            callbackScope: this,
            loop: false
        } );
    }

    update ( time, delta ) {
    }

}

export default InitScene;
